import { render } from "./JudgeStep.vue?vue&type=template&id=174f95ee&scoped=true&ts=true"
import script from "./JudgeStep.vue?vue&type=script&lang=ts"
export * from "./JudgeStep.vue?vue&type=script&lang=ts"

import "./JudgeStep.vue?vue&type=style&index=0&id=174f95ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174f95ee"]])

export default __exports__